export const APPLICATION_NAME = "React";
// Centralized default environment details for use in context and hooks
export const DEFAULT_ENVIRONMENT_DETAILS = {
    buildVersion: "",
    dataDogClientToken: "",
    application: APPLICATION_NAME,
    environment: "",
    graphQLEndpoint: "",
    isLogRocketEnabled: false,
    googleFontsApiKey: "",
    mapBoxApiKey: "",
    urlHost: "",
    loading: true,
    success: false,
    error: null,
    errorMessage: undefined,
    imageBaseURL: "",
};
